import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageKeys } from '@sd-portal/shared/models';
import { AIRCRAFT_TRIP_MODULE_KEY } from 'libs/pre-flight/feature-aircraft-trip/src/lib/+state/aircraft-trip.declarations';
import * as Sentry from '@sentry/browser';

@Component({
  selector: 'sd-post-login',
  templateUrl: './post-login.component.html'
})
export class PostLoginComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit() {
    const redirectUrl = sessionStorage.getItem(SessionStorageKeys.REDIRECT_URL) || '/';

    if (sessionStorage.getItem(SessionStorageKeys.REDIRECT_URL)) {
      sessionStorage.removeItem(SessionStorageKeys.REDIRECT_URL);
    }
    if (sessionStorage.getItem(SessionStorageKeys.TRAININGREQUIREMENTS_FILTER_FORM)) {
      sessionStorage.removeItem(SessionStorageKeys.TRAININGREQUIREMENTS_FILTER_FORM);
    }
    if (window.localStorage.getItem(`${AIRCRAFT_TRIP_MODULE_KEY}|selectedBuildTripViewTypeId`)) {
      window.localStorage.removeItem(`${AIRCRAFT_TRIP_MODULE_KEY}|selectedBuildTripViewTypeId`);
    }
    if (window.localStorage.getItem(`${AIRCRAFT_TRIP_MODULE_KEY}|isReorderLegsDontPrompt`)) {
      window.localStorage.removeItem(`${AIRCRAFT_TRIP_MODULE_KEY}|isReorderLegsDontPrompt`);
    }

    // Parse URL to handle special characters properly
    const urlTree = this.router.parseUrl(redirectUrl);
    this.router.navigateByUrl(urlTree).then((success) => {
      if (!success) {
        Sentry.captureException(new Error('Navigation failed. Trying fallback to root.'));
        this.router.navigate(['/']);
      }
    }).catch((error) => {
      Sentry.captureException(error);
      this.router.navigate(['/']);
    });
  }
}
